import { z } from 'zod';
import { orderAddress } from '../../schema/address.js';
import { Pegasus } from '../../schema/pegasus.js';
// a list of actions from pegasus that can be performed on an order
export const orderEditStartResponse = z.array(Pegasus.orderEditAction);
const cancel = z.object({
    editType: z.literal(`${Pegasus.OrderEditType.CANCEL_ORDER}`),
    action: Pegasus.orderEditCancelOrderActionSchema,
    stagedEdits: z.never().optional(),
});
const updateShippingAddress = z.object({
    editType: z.literal(`${Pegasus.OrderEditType.UPDATE_SHIPPING_ADDRESS}`),
    action: Pegasus.orderEditUpdateAddressActionSchema,
    stagedEdits: z.object({
        updatedShippingAddress: orderAddress,
    }),
});
// used for both the staging response and commit request
export const orderEditCommitOrStage = z.discriminatedUnion('editType', [
    cancel,
    updateShippingAddress,
]);
export const orderEditStageResponse = z.discriminatedUnion('editType', [
    cancel.extend({
        appliedOrderEditId: z.number(),
    }),
    updateShippingAddress.extend({
        appliedOrderEditId: z.number(),
    }),
]);
export const orderEditCommitResponse = z.object({
    ok: z.boolean(),
    message: z.string(),
    editType: Pegasus.orderEditTypeUnion,
});
//# sourceMappingURL=orderEdit.js.map